import styles from './styles.module.scss';
import { NotificationCoinProps } from './props';
import { Image } from '@starsoft/common/components';

/**
 * NotificationCoin Component
 * A component that renders a coin image icon for notifications.
 * Uses environment variables to construct the image URL from an S3 bucket.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.coin - The coin object containing name and image details
 * @param {string} props.coin.name - Name of the coin
 * @param {string} props.coin.image - Image filename for the coin
 * @returns {JSX.Element} The rendered coin image
 *
 * @example
 * // Basic usage
 * <NotificationCoin
 *   coin={{
 *     name: "bitcoin",
 *     image: "btc.png"
 *   }}
 * />
 */
export default function NotificationCoin({ coin }: NotificationCoinProps) {
  return (
    <Image
      className={styles.coin}
      width={16}
      height={16}
      alt={`coin-icon-${coin?.name}`}
      format="square"
      src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${coin?.image}`}
    />
  );
}
